import Vue from 'vue'

export const data = () => ({
  loading: false,
  data: null,
})

export const mutations = {
  setLoading: (state, value) => Vue.set(state, 'loading', !!value),
  setData: (state, data = null) => Vue.set(state, 'data', data),
}

export const actions = {
  async fetch({ commit }) {
    commit('setLoading', true)
    const response = await this.$axios.get('/v3/app/performance')
    commit('setData', response.data)
    commit('setLoading', false)
  },
}
